import styled from 'styled-components';

export const ClientProjectOptionStyle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-right: 5px;
  padding: 5px;
  font-family: inherit;
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  color: ${({ isBlocked, theme }) => {
    if (!isBlocked) {
      return theme.colors.white;
    } else {
      return theme.colors.primary;
    }
  }};
  background-color: ${({ isBlocked, theme }) => {
    if (!isBlocked) {
      return theme.colors.error;
    } else {
      return theme.colors.white;
    }
  }};
  p {
    margin: 0;
  }
  a {
    margin-left: 5px;
    padding: 3px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.superSmall;
    }};
    text-decoration: none;
    cursor: pointer;
    color: ${({ isBlocked, theme }) => {
      if (!isBlocked) {
        return theme.colors.white;
      } else {
        return theme.colors.primary;
      }
    }};
    border: 1px solid
      ${({ isBlocked, theme }) => {
        if (!isBlocked) {
          return theme.colors.white;
        } else {
          return theme.colors.primary;
        }
      }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    transition: background-color 200ms ease-in-out;
    &:hover {
      color: ${({ theme }) => {
        return theme.colors.white;
      }};
      background-color: ${({ theme }) => {
        return theme.colors.primary;
      }};
    }
  }
`;
